import { useTranslation } from "react-i18next";
import {MoreIcon } from "src/assets/Icons";

function OverflowIndicator() {
  const { t } = useTranslation();
  return (
    <div className="h-full! flex items-center justify-center gap-1 text-font-default">
      <MoreIcon strokeWidth={.3} />
      <p>{t("Menu.more")}</p>
    </div>
  );
}

export { OverflowIndicator };
